/*
 * @Author: mkRui 1102163949@qq.com
 * @Date: 2025-10-10 18:20:25
 * @LastEditors: mkRui 1102163949@qq.com
 * @LastEditTime: 2025-11-05 14:10:01
 * @FilePath: /polordar-explorer/ui/shared/DataFetchAlert.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { chakra } from '@chakra-ui/react';
import React from 'react';

import { useTranslation } from 'lib/i18n/LanguageContext';
import { Alert } from 'toolkit/chakra/alert';

const DataFetchAlert = ({ className }: { className?: string }) => {
  const { t } = useTranslation();
  return (
    <Alert status="warning" width="fit-content" className={ className }>
      { t('shared.dataFetchAlert.message') }
    </Alert>
  );
};

export default chakra(DataFetchAlert);
